import { FC, useEffect, useState } from "react";
import { useSettingsStore } from "../../stores/SettingsStore";
import { KTSVG } from "../../_metronic/helpers";
import { useDataTableStore } from "../../stores/DataTableStore";
import { SelectOption } from "../../interfaces/SelectOption";
import axios from "axios";
import useSWR, { mutate } from "swr";
import useAccessToken from "../../hooks/AccessToken";
import useUser from "../../hooks/User";
import { Product } from "../../interfaces/Product";
import { User } from "../../interfaces/User";
import { Progress, SubProgress } from "../../interfaces/Progress";
import { DataTableSelect } from "../DataTable/DataTableSelect";
import { TableColumn } from "react-data-table-component";
import { ContentPipelineProps, Pipeline, SelectDateFilterProps, TemplatePipelineProps } from "../../interfaces/Pipeline";
import { Modal } from "bootstrap";
import { ModifyTemplate } from "./Template/ModifyTemplate";
import Swal from "sweetalert2";
import { getSettingAll, saveSetting } from "../../api/SettingCRUD";
import { DeleteTemplatePipeline } from "./Template/DeleteTemplate";
import { useIntl } from "react-intl";
import { useCustomeStore } from "../../stores/CustomeStore";
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { InputCheckbox } from "../Input/InputCheckbox";
import { useTemplatePipeline } from "../../stores/TemplatePipeline";
import { updateSortTemplatePipeline, updateTemplatePipeline } from "../../api/PipelineCRUD";
import { Dropdown } from "rsuite";
import { handleCaps } from "../../functions/general";
import { usePipelineStore } from "../../stores/PipelineStore";
import { LabelOption } from "../../interfaces/Label";
import useModalEffect from "../../hooks/useModalEffect";
import { Source } from "../../interfaces/Source";
import { DateRangePicker } from "rsuite";
import moment from "moment-timezone";
import useCheckIsMobile from "../../hooks/useCheckIsMobile";
import Select from 'react-select'
import { useParams } from "react-router-dom";
import { Drawer, RadioGroup, Radio, ButtonToolbar, Button, IconButton, Placeholder } from 'rsuite';
import ItemTemplateCompany from "./ItemTemplateCompany";
import ItemTemplatePersonal from "./ItemTemplatePersonal";
import { Unit } from "../../interfaces/Unit";
import { DateRange } from "rsuite/esm/DateRangePicker";
import usePredefinedRanges from "../../hooks/PredefinedRanges";

interface FilterPipelineProps {
    propsData: {
        updatedData: {
            manageColumns: TableColumn<Pipeline>[],
            updatedDataCompany: TemplatePipelineProps[]
            updatedDataPersonal: TemplatePipelineProps[]
        }
        setUpdatedData: {
            setManageColumns: React.Dispatch<React.SetStateAction<TableColumn<Pipeline>[]>>
            setUpdatedDataCompany: React.Dispatch<React.SetStateAction<TemplatePipelineProps[]>>
            setUpdatedDataPersonal: React.Dispatch<React.SetStateAction<TemplatePipelineProps[]>>
        }
        handleDragEnd: {
            handleDragEndColumn: (event: any) => void
            handleDragEndCompany: (event: any) => void
            handleDragEndPersonal: (event: any) => void
        }
        sensors: {
            sensorsColumn: any
            sensorsCompany: any
            sensorsPersonal: any
        }
        hasChanges?: {
            hasChangesCompany: boolean
            hasChangesPersonal: boolean
        }
        cancelChanges: {
            cancelChangesCompany: () => void
            cancelChangesPersonal: () => void
        }
        initializeData?: {
            initializeDataCompany: (data: any[]) => void
            initializeDataPersonal: (data: any[]) => void
        }
    }
    handleResetFilter: () => void
    selectAllColumn: boolean
    setSelectAllColumn: React.Dispatch<React.SetStateAction<boolean>>
}

const FilterPipeline: FC<FilterPipelineProps> = ({ propsData, handleResetFilter, selectAllColumn, setSelectAllColumn }) => {
    const API_URL = process.env.REACT_APP_API_URL
    const { userTemplatePipeline, companyTemplatePipeline, setUserTemplatePipeline, setCompanyTemplatePipeline } = useTemplatePipeline()
    const { setMasterDateRange, masterDateRange, setTypeDateFilter, typeDateFilter, setSelectDateFilter, selectDateFilter, fetchCounter, setFetchCounter } = useDataTableStore()
    const { selectMultiPipeline } = usePipelineStore()
    const { settings, setSettings } = useSettingsStore()
    const { selectedFilters, setSelectedFilter } = useDataTableStore();
    const token = useAccessToken()
    const { isMobile } = useCheckIsMobile()
    const user = useUser()
    const { companyId } = useCustomeStore()
    const [showModifyTemplateModal, setShowModifyTemplateModal] = useState<boolean>(false);
    const [showDeleteTemplateModal, setShowDeleteTemplateModal] = useState<boolean>(false);
    const [type, setType] = useState<string>("");
    const [searchColumn, setSearchColumn] = useState<string>("");
    const [productData, setProductData] = useState<SelectOption[]>([]);
    const [usersData, setUsersData] = useState<SelectOption[]>([]);
    const [unitData, setUnitData] = useState<SelectOption[]>([]);
    const [allUserData, setAllUserData] = useState<SelectOption[]>([]);
    const [subProgressData, setSubProgressData] = useState<SelectOption[]>([]);
    const [progressData, setProgressData] = useState<SelectOption[]>([]);
    const [sourceData, setSourceData] = useState<SelectOption[]>([]);
    const [template, setTemplate] = useState<TemplatePipelineProps>({} as TemplatePipelineProps);
    const intl = useIntl()
    const [labelsData, setLabelsData] = useState<SelectOption[]>([]);
    const { templatePipelineId } = useParams()
    const predefinedRanges = usePredefinedRanges()

    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const progressTypesData: SelectOption[] = [
        {
            value: "ONGOING",
            label: intl.formatMessage({ id: "PROGRESS.TYPE.ONGOING" })
        },
        {
            value: "SUCCESS",
            label: intl.formatMessage({ id: "PROGRESS.TYPE.SUCCESS" })
        },
        {
            value: "FAIL",
            label: intl.formatMessage({ id: "PROGRESS.TYPE.FAIL" })
        }
    ]

    const optionsTypeDate = [
        { value: '1', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_CREATED" }) },
        { value: '2', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_STARTED" }) },
        { value: '3', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_ENDED" }) },
    ]

    const selectConfigs = [
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "MENU.PRODUCTS" })}`,
            tableKey: 'pipelines',
            filterKey: 'leadProducts',
            options: productData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'leadProducts', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.LABELS" })} ${intl.formatMessage({ id: "FORM.OPTION.TYPE.PRODUCT" })}`,
            tableKey: 'pipelines',
            filterKey: 'leadProductLabels',
            options: labelsData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'leadProductLabels', values)
        },

        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.PROGRESS_TYPE" })}`,
            tableKey: 'pipelines',
            filterKey: 'lead_progress_progress_type',
            options: progressTypesData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'lead_progress_progress_type', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "MENU.PROGRESSES" })}`,
            tableKey: 'pipelines',
            filterKey: 'lead_progress_name',
            options: progressData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'lead_progress_name', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.SUBPROGRESS" })}`,
            tableKey: 'pipelines',
            filterKey: 'lead_subprogress_name',
            options: subProgressData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'lead_subprogress_name', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.PIC" })}`,
            tableKey: 'pipelines',
            filterKey: 'owner_name',
            options: usersData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'owner_name', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.MENU.SOURCES" })}`,
            tableKey: 'pipelines',
            filterKey: 'lead_source_name',
            options: sourceData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'lead_source_name', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.CREATED_BY" })}`,
            tableKey: 'pipelines',
            filterKey: 'creator_name',
            options: allUserData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'creator_name', values)
        },
        {
            placeholder: `${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.UNITS" })}`,
            tableKey: 'pipelines',
            filterKey: 'unitNames',
            options: unitData,
            onChange: (values: string[]) => setSelectedFilter('pipelines', 'unitNames', values)
        }
    ];

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const getUserURL = () => {
        if (user.data.permission_pipeline_create === "ALL") {
            return `${API_URL}users`
        } else {
            return `${API_URL}user/subordinates`
        }
    }

    const { data: products = [], error: productsError, isLoading: productsLoading } = useSWR(selectMultiPipeline.id ? `${API_URL}lead-template-product-accesses/${selectMultiPipeline.id}` : null, fetcher)
    const { data: users = [], error: usersError, isLoading: usersLoading } = useSWR(getUserURL(), fetcher)
    const { data: progress = [], error: progressError, isLoading: progressLoading, mutate: mutateProgress } = useSWR(`${API_URL}lead_progresses?onlyShowAllowedForCreateLeadLog=true&leadTemplateId=${templatePipelineId}`, fetcher)
    const { data: labelsProduct = [], error: labelsError, isLoading: labelsLoading } = useSWR<LabelOption[]>(`${API_URL}labels?usableBy[]=product`, fetcher)
    const { data: sources = [], error: sourcesError, isLoading: sourcesLoading } = useSWR(`${API_URL}lead_sources`, fetcher)
    const { data: allUsers = [], error: allUsersError, isLoading: allUsersLoading } = useSWR(`${API_URL}user/company`, fetcher)
    const { data: units = [], error: unitsError, isLoading: unitsLoading } = useSWR(`${API_URL}units`, fetcher)


    const handleSaveTemplateOrderCompany = async () => {
        try {
            const updateData = propsData.updatedData.updatedDataCompany.map((template, index) => ({
                ...template,
                id: template.id,
                position: index
            }));

            const response = await updateSortTemplatePipeline(updateData, token, 'company');
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" }),
                    timer: 2000,
                    timerProgressBar: true,
                });
                const sortDataByPosition = response.data.data.sort((a: any, b: any) => a.position - b.position)
                propsData.initializeData?.initializeDataCompany(sortDataByPosition)
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error saving template order',
                text: error.response?.data?.message || 'An error occurred'
            });
        }
    };

    const handleSaveTemplateOrderPersonal = async () => {
        try {
            const updateData = propsData.updatedData.updatedDataPersonal.map((template, index) => ({
                ...template,
                id: template.id,
                position: index
            }));

            const response = await updateSortTemplatePipeline(updateData, token, 'personal');
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" }),
                    timer: 2000,
                    timerProgressBar: true,
                });
                const sortDataByPosition = response.data.data.sort((a: any, b: any) => a.position - b.position)
                propsData.initializeData?.initializeDataPersonal(sortDataByPosition)
            }

        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error saving template order',
                text: error.response?.data?.message || 'An error occurred'
            });
        }
    }

    const renderButton = (props: any, ref: any) => {
        return (
            <button {...props} ref={ref} className="btn btn-sm btn-light-linkedin" style={{ padding: "7px 12px", fontSize: "x-small" }}>
                <i className="fas fa-plus"></i> {intl.formatMessage({ id: "FILTER.LABEL.DATABASE.ADD" })}
            </button>
        );
    };

    const handleDateRangeChange = (value: DateRange | null) => {
        if (!value) {
            setMasterDateRange({
                pipeline: null,
                merchant: null
            })
            return;
        }

        const startDateTime = moment(value[0]).startOf('day');
        const endDateTime = moment(value[1]).endOf('day');

        setMasterDateRange({
            pipeline: {
                startDate: startDateTime.toDate(),
                endDate: endDateTime.toDate()
            },
            merchant: null
        })
    };

    const handleUseTemplate = (template: TemplatePipelineProps) => {
        setSelectedFilter('pipelines', 'leadProducts', template.content.filter.leadProducts || [])
        setSelectedFilter('pipelines', 'lead_progress_progress_type', template.content.filter.lead_progress_progress_type ? template.content.filter.lead_progress_progress_type : ['ONGOING', 'SUCCESS'])
        setSelectedFilter('pipelines', 'lead_progress_name', template.content.filter.lead_progress_name || [])
        setSelectedFilter('pipelines', 'lead_subprogress_name', template.content.filter.lead_subprogress_name || [])
        setSelectedFilter('pipelines', 'owner_name', template.content.filter.owner_name || [])
        setSelectedFilter('pipelines', 'leadProductLabels', template.content.filter.leadProductLabels || [])
        setSelectedFilter('pipelines', 'lead_source_name', template.content.filter.lead_source_name || [])
        setSelectedFilter('pipelines', 'creator_name', template.content.filter.creator_name || [])
        setSelectedFilter('pipelines', 'unitNames', template.content.filter.unitNames || [])
        setSelectDateFilter(template.content.filter_date_range)

        setUserTemplatePipeline(
            (propsData.updatedData.updatedDataPersonal || userTemplatePipeline).map(item => {
                if (item.id === template.id) {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: true
                        }
                    }
                } else {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: false
                        }
                    }
                }
            })
        )
        setCompanyTemplatePipeline(
            (propsData.updatedData.updatedDataCompany || companyTemplatePipeline).map(item => {
                if (item.id === template.id) {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: true
                        }
                    }
                } else {
                    return {
                        ...item,
                        content: {
                            ...item.content,
                            use: false
                        }
                    }
                }
            })
        )

        propsData.updatedData.manageColumns.map((columnItem: TableColumn<Pipeline>) => {
            columnItem.omit = template.content.hide.includes(columnItem.id as string);
        });

        propsData.updatedData.manageColumns.sort((a: any, b: any) => {
            const indexA = template.content.sort.indexOf(a.id);
            const indexB = template.content.sort.indexOf(b.id);

            // Jika salah satu ID tidak ada dalam template, tetap di posisi awal
            if (indexA === -1 || indexB === -1) {
                return 0;
            }

            return indexA - indexB;
        });

        if (propsData.updatedData.manageColumns.filter(column => column.omit !== true).length === propsData.updatedData.manageColumns.length) {
            setSelectAllColumn(true)
        } else {
            setSelectAllColumn(false)
        }

        propsData.setUpdatedData.setManageColumns([...propsData.updatedData.manageColumns])
    }

    const handleUpdateUserTemplate = async (typeTemplate: string, template: TemplatePipelineProps) => {
        var dataSort: string[] = []
        var dataHide: string[] = []
        propsData.updatedData.manageColumns.map(item => {
            dataSort.push(item.id as string);

            if (item.omit === true) {
                dataHide.push(item.id as string);
            }
        });

        const dataTemplate: ContentPipelineProps = {
            hide: dataHide,
            sort: dataSort,
            use: false,
            filter: {
                leadProducts: [...selectedFilters['pipelines'].leadProducts],
                lead_progress_name: [...selectedFilters['pipelines'].lead_progress_name],
                lead_subprogress_name: [...selectedFilters['pipelines'].lead_subprogress_name],
                lead_progress_progress_type: [...selectedFilters['pipelines'].lead_progress_progress_type],
                owner_name: [...selectedFilters['pipelines'].owner_name],
                leadProductLabels: [...selectedFilters['pipelines'].leadProductLabels],
                lead_source_name: [...selectedFilters['pipelines'].lead_source_name],
                creator_name: [...selectedFilters['pipelines'].creator_name],
                unitNames: [...selectedFilters['pipelines'].unitNames],
            },
            filter_date_range: {
                typeDateFilter: typeDateFilter,
                startDate: masterDateRange.pipeline?.startDate as Date,
                endDate: masterDateRange.pipeline?.endDate as Date
            },
        }

        try {
            const response = await updateTemplatePipeline(template.id, selectMultiPipeline.id, template.name, JSON.stringify(dataTemplate), token)
            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    heightAuto: false,
                    title: `${intl.formatMessage({ id: "FORM.VALIDATION.SAVE_SUCCESS" })}`,
                    timer: 2000,
                    timerProgressBar: true
                })

                if (typeTemplate === 'update-template-user') {
                    setUserTemplatePipeline(userTemplatePipeline.map(item => {
                        if (item.id === template.id) {
                            return {
                                ...item,
                                content: {
                                    ...dataTemplate,
                                    use: template.content.use
                                }
                            }
                        } else {
                            return item
                        }
                    }));
                } else if (typeTemplate === 'update-template-company') {
                    setCompanyTemplatePipeline(companyTemplatePipeline.map(item => {
                        if (item.id === template.id) {
                            return {
                                ...item,
                                content: {
                                    ...dataTemplate,
                                    use: template.content.use
                                }
                            }
                        } else {
                            return item
                        }
                    }));
                }
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok'
            });
        }
    }

    const handleCheckUseTemplate = () => {
        const pipelines = selectedFilters.pipelines;
        if (!pipelines) return false;

        const hasOmittedColumns = propsData.updatedData.manageColumns.some((data: TableColumn<Pipeline>) => data.omit === true);
        const hasRelevantFilters = pipelines.leadProducts?.length > 0 || pipelines.lead_progress_name?.length > 0 || pipelines.lead_subprogress_name?.length > 0 || pipelines.owner_name?.length > 0 || pipelines.leadProductLabels?.length > 0 || pipelines.labels?.length > 0
            || pipelines.lead_source_name?.length > 0 || pipelines.creator_name?.length > 0 || pipelines.unitNames?.length > 0 || masterDateRange.pipeline?.startDate;
        const isLeadProgressTypeIncomplete = () => {
            const progressTypes: string[] | string = pipelines.lead_progress_progress_type || [];
            return !(progressTypes.includes("ONGOING") && progressTypes.includes("SUCCESS") && progressTypes.length === 2);
        };

        return hasOmittedColumns || hasRelevantFilters || isLeadProgressTypeIncomplete();
    };

    const handleClickAllColumn = () => {
        const newManageColumns = [...propsData.updatedData.manageColumns];
        newManageColumns.map((data: TableColumn<Pipeline>) => (data.omit = selectAllColumn));
        propsData.setUpdatedData.setManageColumns(newManageColumns);
        setSelectAllColumn(!selectAllColumn);
    }

    useEffect(() => {
        if (!productsLoading) {
            const productsData = products.map((products: Product) => ({
                value: products.name,
                label: products.name
            }));

            setProductData(productsData)
        }
    }, [products])

    useEffect(() => {
        if (!sourcesLoading) {
            const sourcesData = sources.map((source: Source) => ({
                value: source.name,
                label: source.name
            }));

            setSourceData(sourcesData)
        }
    }, [sources])

    useEffect(() => {
        if (!unitsLoading) {
            const unitsData = units.map((unit: Unit) => ({
                value: unit.name,
                label: unit.name
            }));
            const newValue = [...unitsData, { value: 'PCS', label: 'PCS' }]
            setUnitData(newValue)
        }
    }, [units])

    useEffect(() => {
        if (!usersLoading) {
            const usersData = users.map((user: User) => ({
                value: user.name,
                label: user.name
            }));

            if (user.data.permission_pipeline_create !== "ALL") {
                usersData.unshift({ value: user.data.name, label: user.data.name })
            }

            setUsersData(usersData);
        }
    }, [users]);

    useEffect(() => {
        if (masterDateRange.pipeline?.startDate && masterDateRange.pipeline?.endDate) {
            // mutate(`${API_URL}v2/leads`);
            setFetchCounter(fetchCounter + 1)
        }
    }, [typeDateFilter, masterDateRange])

    useEffect(() => {
        if (!allUsersLoading) {
            const allUserData = allUsers.map((user: User) => ({
                value: user.name,
                label: user.name
            }));

            setAllUserData(allUserData);
        }
    }, [allUsers]);

    useEffect(() => {
        if (progressLoading) return;

        const { lead_progress_name, lead_progress_progress_type } = selectedFilters?.pipelines || {};
        const isElgisa = user.data.company_id === companyId.elgisa;

        // Filter data by name or type
        const filteredProgress = progress.filter((progress: Progress) => {
            if (lead_progress_name?.length) {
                return lead_progress_name.includes(progress.name);
            } else if (lead_progress_progress_type?.length) {
                return lead_progress_progress_type.includes(progress.progress_type);
            }
            return true;
        });

        // Build progress data if filtering by type or no filter
        if (!lead_progress_name?.length) {
            const progressOptions = filteredProgress.map((progress: Progress) => ({
                subProgress: progress.sub_progress,
                value: progress.name,
                label: progress.name,
            }));

            if (!isElgisa && lead_progress_progress_type?.includes("ONGOING")) {
                const label = intl.formatMessage({ id: "FORM.LABEL.NEW" });
                progressOptions.unshift({ label, value: label });
            }

            if (isElgisa) {
                progressOptions.unshift(
                    { label: "New-Sales", value: "NEW-Sales" },
                    { label: "New-Service", value: "NEW-Service" }
                );
            }

            setProgressData(progressOptions);

            // extract sub-progress
            const subProgress = progressOptions.flatMap((option: SelectOption) => option.subProgress || []);
            const uniqueSub = Array.from(
                new Map(subProgress.map((subProgress: SubProgress) => [subProgress.id, { id: subProgress.id, value: subProgress.name, label: subProgress.name }])).values()
            ) as SelectOption[];
            setSubProgressData(uniqueSub);
        } else {
            // extract sub-progress from name-filtered data
            const subProgress = filteredProgress.flatMap((progress: Progress) => progress.sub_progress || []);
            const uniqueSub = Array.from(
                new Map(subProgress.map((subProgress: SubProgress) => [subProgress.id, { id: subProgress.id, value: subProgress.name, label: subProgress.name }])).values()
            ) as SelectOption[];
            setSubProgressData(uniqueSub);
        }
    }, [progress, selectedFilters?.pipelines?.lead_progress_name, selectedFilters?.pipelines?.lead_progress_progress_type,]);

    useEffect(() => {
        if (!labelsLoading) {
            setLabelsData(labelsProduct.map((label: LabelOption) => ({
                value: label.name,
                label: label.name
            })))
        }
    }, [labelsProduct])

    useModalEffect({
        showModal: showDeleteTemplateModal,
        setShowModal: setShowDeleteTemplateModal,
        modalId: `delete-template-pipeline-modal-${template.id}`
    })

    useEffect(() => {
        setSelectedFilter('pipelines', 'leadProducts', [])
        setSelectedFilter('pipelines', 'lead_progress_progress_type', ['ONGOING', 'SUCCESS'])
        setSelectedFilter('pipelines', 'lead_progress_name', [])
        setSelectedFilter('pipelines', 'lead_subprogress_name', [])
        setSelectedFilter('pipelines', 'owner_name', [])
        setSelectedFilter('pipelines', 'leadProductLabels', [])
        setSelectedFilter('pipelines', 'labels', [])
        setSelectedFilter('pipelines', 'lead_source_name', [])
        setMasterDateRange({
            pipeline: null,
            merchant: null
        })
        setTypeDateFilter('1')
        setSelectDateFilter({} as SelectDateFilterProps)
        setSelectedFilter('pipelines', 'creator_name', [])
        setSelectedFilter('pipelines', 'unitNames', [])
    }, [templatePipelineId])

    useEffect(() => {
        if (selectDateFilter?.typeDateFilter && selectDateFilter?.startDate && selectDateFilter?.endDate) {
            setMasterDateRange({
                pipeline: {
                    startDate: new Date(selectDateFilter.startDate),
                    endDate: new Date(selectDateFilter.endDate)
                },
                merchant: null
            })
            setTypeDateFilter(selectDateFilter.typeDateFilter)
        } else {
            setMasterDateRange({
                pipeline: null,
                merchant: null
            })
            setTypeDateFilter('1')
        }
    }, [selectDateFilter])

    useEffect(() => {
        const removeErrorClass = () => {
            const errorPickers = document.querySelectorAll('.rs-picker-error');

            errorPickers.forEach(picker => {
                picker.classList.remove('rs-picker-error');
            });
        };

        removeErrorClass();

        const intervalId = setInterval(removeErrorClass, 100);

        const handlePickerOpen = () => {
            setTimeout(removeErrorClass, 10);
        };

        document.addEventListener('click', handlePickerOpen);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('click', handlePickerOpen);
        };
    }, []);

    return (
        <div>
            {
                (handleCheckUseTemplate()) ?
                    <>
                        <button className="btn mt-3 me-3" style={{ backgroundColor: "#f1faff", border: "2px solid #009EF7", padding: "calc(0.75rem) calc(1.5rem)" }} onClick={() => setIsOpenDrawer(true)}>
                            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 svg-icon-primary m-0' />
                        </button>
                        <button type="button"
                            className="btn btn-white mt-3 text-primary"
                            onClick={() => { handleResetFilter() }}
                        >
                            Reset Filter
                        </button>
                    </>
                    :
                    <button type="button" className="btn btn-light mt-3" onClick={() => setIsOpenDrawer(true)}>
                        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2 m-0' />
                    </button>
            }

            <Drawer
                className="bg-white"
                size={isMobile ? "xs" : "md"}
                placement="right"
                open={isOpenDrawer}
                onClose={() => setIsOpenDrawer(false)}
                style={{ height: "100%", overflowY: "auto" }}
            >
                <div className="card rounded-0" style={{ height: "100%" }} id="kt_drawer_filter_pipeline">
                    <div className="card-header pe-5">
                        <div className="card-title">
                            <div className="d-flex justify-content-center flex-column me-3">
                                <span className="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1">Filter {settings.pipeline_title}</span>
                            </div>
                        </div>
                        <div className="card-toolbar">
                            <div className="btn btn-sm btn-icon btn-active-light-primary" onClick={() => setIsOpenDrawer(false)}>
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{ fontWeight: "600" }}>{intl.formatMessage({ id: "FILTER.LABEL.DATABASE.LIST" })}</div>
                            <div>
                                {
                                    user.data.is_superadmin ?
                                        <Dropdown renderToggle={renderButton} title={`${intl.formatMessage({ id: 'FORM.ACTION.ADD' })} ${settings.meeting_title}`} noCaret placement="bottomEnd">
                                            <Dropdown.Item onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-user") }}>Personal</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-company") }}>Company</Dropdown.Item>
                                        </Dropdown>
                                        :
                                        <button className="btn btn-sm btn-light-linkedin" onClick={() => { setShowModifyTemplateModal(true); setType("insert-template-user") }} style={{ padding: "7px 12px", fontSize: "x-small" }}>{intl.formatMessage({ id: "FILTER.LABEL.DATABASE.ADD" })}</button>
                                }
                            </div>
                        </div>
                        <div className="separator separator-dashed my-3"></div>
                        <div className="d-flex justify-content-between align-items-center" style={{ height: '30px' }}>
                            {
                                propsData.updatedData.updatedDataCompany.length > 0 &&
                                <small>Company</small>
                            }

                            {/* {
                                propsData.hasChanges?.hasChangesCompany && (
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={propsData.cancelChanges.cancelChangesCompany}
                                        style={{ padding: "7px 12px", fontSize: "x-small" }}
                                    >
                                        {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                    </button>
                                )
                            } */}

                            {propsData.hasChanges?.hasChangesCompany && (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleSaveTemplateOrderCompany}
                                    style={{ padding: "7px 12px", fontSize: "x-small" }}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.SAVE_CHANGES" })}
                                </button>
                            )}
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndCompany} sensors={propsData.sensors.sensorsCompany} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.updatedDataCompany as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.updatedDataCompany.map((dataCompanyTemplate: TemplatePipelineProps, index) => {
                                        return (
                                            <ItemTemplateCompany
                                                key={index}
                                                id={dataCompanyTemplate.id}
                                                dataCompanyTemplate={dataCompanyTemplate}
                                                handleUseTemplate={handleUseTemplate}
                                                setShowModifyTemplateModal={setShowModifyTemplateModal}
                                                setType={setType}
                                                setTemplate={setTemplate}
                                                handleUpdateUserTemplate={handleUpdateUserTemplate}
                                                setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>

                        <div className="d-flex justify-content-between align-items-center" style={{ height: '30px' }}>
                            {
                                propsData.updatedData.updatedDataPersonal.length > 0 &&
                                <small>Personal</small>
                            }

                            {/* {
                                propsData.hasChanges?.hasChangesPersonal && (
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={propsData.cancelChanges.cancelChangesPersonal}
                                        style={{ padding: "7px 12px", fontSize: "x-small" }}
                                    >
                                        {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                    </button>
                                )
                            } */}

                            {propsData.hasChanges?.hasChangesPersonal && (
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleSaveTemplateOrderPersonal}
                                    style={{ padding: "7px 12px", fontSize: "x-small" }}
                                >
                                    {intl.formatMessage({ id: "FORM.ACTION.SAVE_CHANGES" })}
                                </button>
                            )}
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndPersonal} sensors={propsData.sensors.sensorsPersonal} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.updatedDataPersonal as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.updatedDataPersonal.map((dataUserTemplate: TemplatePipelineProps, index) => {
                                        return (
                                            <ItemTemplatePersonal
                                                key={index}
                                                id={dataUserTemplate.id}
                                                dataUserTemplate={dataUserTemplate}
                                                handleUseTemplate={handleUseTemplate}
                                                setShowModifyTemplateModal={setShowModifyTemplateModal}
                                                setType={setType}
                                                setTemplate={setTemplate}
                                                handleUpdateUserTemplate={handleUpdateUserTemplate}
                                                setShowDeleteTemplateModal={setShowDeleteTemplateModal}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>

                        <div className="mt-10" style={{ fontWeight: "600" }}>Filter Data</div>
                        <div className="separator separator-dashed my-3"></div>
                        {
                            selectConfigs.map((config, index) => (
                                <DataTableSelect
                                    placeholder={config.placeholder}
                                    tableKey={config.tableKey}
                                    filterKey={config.filterKey}
                                    key={index}
                                    options={config.options}
                                    onChange={config.onChange}
                                    manageColumns={propsData.updatedData.manageColumns}
                                    setManageColumns={propsData.setUpdatedData.setManageColumns}
                                />
                            ))
                        }
                        <div className="mt-10 d-flex flex-column gap-2">
                            <div style={{ fontWeight: "600" }}>
                                {intl.formatMessage({ id: "FORM.LABEL.FILTER_DATE" })}
                            </div>
                            <div className="separator separator-dashed my-3"></div>
                            <Select
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: "none",
                                        width: "100%"
                                    }),
                                    option: (baseStyles, { isSelected, isFocused }) => ({
                                        ...baseStyles,
                                        backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                        cursor: 'pointer',
                                    }),
                                    menu: (baseStyles) => ({
                                        ...baseStyles,
                                        zIndex: 9999
                                    }),
                                }}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: 'none',
                                    },
                                })}
                                onChange={(data: any) => { setTypeDateFilter(data.value) }}
                                value={optionsTypeDate.find(option => option.value === typeDateFilter)}
                                className='react-select-styled z-index-3'
                                classNamePrefix='react-select'
                                options={optionsTypeDate}
                                placeholder='Select an option'
                                isSearchable={false}
                            />

                            <DateRangePicker
                                value={[masterDateRange.pipeline?.startDate as Date, masterDateRange.pipeline?.endDate as Date]}
                                onChange={handleDateRangeChange}
                                style={{ zIndex: '1' }}
                                format="dd MMM yyyy"
                                placeholder={intl.formatMessage({ id: "FORM.LABEL.SELECT_DATE_RANGE" })}
                                className="w-100 custom-rs-datepicker override-border-color"
                                container={() => document.getElementById('kt_drawer_filter_pipeline') as HTMLElement}
                                showOneCalendar={isMobile}
                                editable={false}
                                onClean={() => {
                                    setMasterDateRange({
                                        pipeline: null,
                                        merchant: null
                                    })
                                }}
                                ranges={predefinedRanges}
                            />

                        </div>
                        <div className="mt-10" style={{ fontWeight: "600" }}>{intl.formatMessage({ id: "FORM.LABEL.MANAGE_COLUMN" })}</div>
                        <div className="separator separator-dashed my-3"></div>
                        <div className="d-flex align-items-center bg-hover-light-primary rounded-2 w-100" style={{ padding: "5px" }} onClick={handleClickAllColumn}>
                            <div className="form-check form-check-custom form-check-solid">
                                <input className="form-check-input" type="checkbox" checked={selectAllColumn} readOnly />
                            </div>
                            <span className="form-check-label fw-bolder ms-2 w-100">{intl.formatMessage({ id: "FORM.ACTION.SELECT_ALL" })}</span>
                        </div>
                        <DndContext onDragEnd={propsData.handleDragEnd.handleDragEndColumn} sensors={propsData.sensors.sensorsColumn} collisionDetection={closestCenter}>
                            <SortableContext items={propsData.updatedData.manageColumns as any} strategy={verticalListSortingStrategy}>
                                {
                                    propsData.updatedData.manageColumns.map((data: TableColumn<Pipeline>, index: number) => {
                                        return (
                                            <InputCheckbox
                                                key={index}
                                                id={data.id as string}
                                                manageColumns={propsData.updatedData.manageColumns}
                                                setManageColumns={propsData.setUpdatedData.setManageColumns}
                                                setSelectAllColumn={setSelectAllColumn}
                                                index={index}
                                            />
                                        )
                                    })
                                }
                            </SortableContext>
                        </DndContext>
                    </div>
                </div>
            </Drawer >

            {
                showModifyTemplateModal && <ModifyTemplate type={type} manageColumns={propsData.updatedData.manageColumns} template={template} isOpen={showModifyTemplateModal} onClose={() => setShowModifyTemplateModal(false)} />
            }
            {
                showDeleteTemplateModal && <DeleteTemplatePipeline type={type} template={template} reset={handleResetFilter} />
            }
        </div >
    )
}

export { FilterPipeline }